const ProductionCardLoader = () => {
  return (
    <>
      <div className="prod-card-loader">
        <div className="img"></div>
        <div className="text">
          <p></p>
          <p className="sm"></p>
          <p className="xs"></p>
        </div>
      </div>
    </>
  );
};

export default ProductionCardLoader;
